
<div class="val-page-acces-refuse val-flex-conteneur">
  <div class="val-flex-1"></div>
  <div class="val-flex-conteneur val-flex-colonne">
    <div class="val-flex-1"></div>
    <div class="val-page-acces-refuse-panel val-flex-conteneur val-flex-colonne">
      <div class="val-page-acces-refuse-panel-entete">
        <div class="val-page-acces-refuse-panel-entete-icone">
          <val-fonte-icone iconeCss="fas fa-lock"></val-fonte-icone>
        </div>
        <div class="val-page-acces-refuse-panel-entete-titre">Accès refusé</div>
      </div>
      <div class="val-page-acces-refuse-panel-contenu val-flex-conteneur val-flex-colonne val-flex-1">
        <div class="val-page-acces-refuse-message">
          Vous n’avez pas accès à cette application. Contactez votre administrateur si vous pensez
          qu’il s’agit d’une erreur.
        </div>
        <div class="val-flex-1"></div>
        <div class="val-page-acces-refuse-commande val-flex-conteneur">
          <div class="val-flex-1"></div>
          <button class="val-page-acces-refuse-bouton"
                  (click)="Deconnecter()">
            Se déconnecter
          </button>
          <div class="val-flex-1"></div>
        </div>
      </div>
    </div>
    <div class="val-flex-1"></div>
  </div>
  <div class="val-flex-1"></div>
</div>
